<template>
  <main class="main" role="main">
    <div class="main__inner"><!-- 배경: bg-->
      <div class="main__con">
        <div class="notice__page" style="height: 0;">
          <div class="notice__page__li type_04">
            <div class="txt">
              <p>{{ inquireDetail.boardTitle }}</p>
              <p class="date">{{ $moment(inquireDetail.regDate).format('YYYY.MM.DD') }}<span class="date ml10"><i class="i_time_gr50"></i>{{ $moment(inquireDetail.regDate).format('HH:mm') }}</span></p>
            </div>
          </div>
          <div class="txt__inner" v-html="inquireDetail.boardDescription">
<!--            <p>목숨이 긴지라 천하를 소리다.이것은 듣기만 몸이 인도하겠다는 보는 반짝이는 것이다. 우리 커다란 예가 있으며, 용감하고 것이다. 싸인 더운지라 얼음과 몸이 끓는 그림자는 속에 것이다. 품에 청춘 과실이 심장의 봄바람이다. 설레는 심장의 내는 때에, 열락의 풀이 사람은 힘있다. 열락의 방지하는 가지에 공자는 많이 인생의 듣는다. 고동을 바로 우리의 눈이 그들에게 보이는 것이 창공에 말이다. 위하여, 무엇이 주며, 사막이다. 위하여서 그들에게 원대하고, 청춘의 않는 그들에게 불러 약동하다. 위하여 청춘이 이상 가지에 것이다.</p>-->
          </div>
          <div class="line_10" style="margin: 3.6rem 0 2.6rem 0;" v-if="inquireDetail.isAnswer === 1"></div>
          <div class="answer" v-if="inquireDetail.isAnswer === 1">
            <div class="txt editor">
              <p class="date right">{{ $moment(inquireDetail.answerDate).format('YYYY.MM.DD') }}<span class="date ml10"><i class="i_time_gr50"></i>{{ $moment(inquireDetail.answerDate).format('HH:mm') }}</span></p>
              <p v-html="inquireDetail.answerDescription"></p>
            </div>
          </div>
        </div>
      </div>
      <div class="btn_wrap btn_wrap__fixed">
        <button class="btm bo_yellow" @click="fnDelete">삭제하기</button> <!--하단 버튼 2개일 시 활성화(on) 계속 되어있습니다.-->
        <button class="btm on" @click="fnForm">수정하기</button>
      </div>
    </div>
  </main>
</template>
<script>
export default {
  data: function () {
    return {
      isShow: false,
      params: {
        boardNo: this.$route.query.boardNo
      },
      inquireDetail: {}
    }
  },
  created: function () {
    this.getInquireDetail()
  },
  methods: {
    getInquireDetail: function () {
      this.$MypageSvc.getBoardDetail(this.params)
        .then(res => {
          const code = res.code
          const message = res.message
          const entity = res.entity

          console.log('code: %d\nmessage: %s\nentity: %o\nstringify: \n%s', code, message, entity, JSON.stringify(entity))
          if (code === 1) {
            this.isShow = true
            this.inquireDetail = entity
          }
        })
    },
    fnDelete: function () {
      this.$Util.modalConfirm(this.$ConstCode.CONFIRM_TYPE.DELETE, {}, async () => {
        const res = await this.$MypageSvc.deleteInquire(this.params)
        const code = res.code
        const message = res.message
        const entity = res.entity

        console.log('code: %d\nmessage: %s\nentity: %o\nstringify: \n%s', code, message, entity, JSON.stringify(entity))
        const _this = this
        if (code === 1) {
          setTimeout(function () {
            _this.$router.go(-1)
          }, 200)
        } else {
          setTimeout(function () {
            _this.$Util.modalAlert({message: message})
          }, 200)
        }
      })
    },
    fnForm: function () {
      this.$router.push({
        path: '/mypage/inquireForm',
        query: {boardNo: this.params.boardNo}
      })
    },
  }
}
</script>
